import fDay from './filters/day'
const Core = {}
Core.install = function (Vue) {
  Vue.filter('day', fDay)
}
export default Core
